import { CartStatusEnum } from '@on-arte/core-types';

export const allowedCartsStatuses: CartStatusEnum[] = [
  CartStatusEnum.Initiated,
  CartStatusEnum.Conflicted,
  CartStatusEnum.Collected,
  CartStatusEnum.Accepted,
];
